import { ApprovalType, getApproval } from "src/components/survey/SurveyFormModel";
import { DisplayLabels, Model, Pair } from "src/components/survey/ApplicationIdentity/model/utils";
import { ApprovalStatusBadge } from "src/components/ApprovalStatuses/ApprovalStatusBadge";

export function accountingStatus(model: Model): Pair {
    const type = ApprovalType.AccountingApproval;
    const approval = getApproval(model.application, type);
    return {
        label: DisplayLabels.AccountingStatus,
        value: ApprovalStatusBadge({ status: approval.status, type: type }),
    };
}
